import $ from 'jquery';
import i18n, { t }  from '../../i18n/i18n.js';
import View from '../../../controls/View.js';
import app from '../../App.js';
import FileHelper from '../../../appHelpers/FileHelper.js';
import Vue from 'vue';
import importContactApp from './ImportContactVue/ContactsImport.vue';

var ContactsImportPage = View.extend({

    initialize: function (options) {

        this.options = options = options || {};

        this.vueApp = new Vue({
            data: options,
            render: function (h) {
                return h(importContactApp, {
                    props: {
                        projectId: this.projectId
                    }
                })
            }
        });

        this.vueApp.$mount();
        this.$el.append(this.vueApp.$el);

        return this;

    },

    setupFileField: function () { // TODO: Move to vue

        var that = this,
            $content = that.$table,
            $fileInput = $content.find('input[data-name=import_file]');

        $content.find('button[data-name=import_file_choose]').click(function () {
            $content.find('input[data-name=import_file]').click();
        });

        $fileInput.change(function () {
            var fn = this.value.split(/[/\\]/g);
            fn = fn[fn.length - 1];
            $content.find('input[data-name=import_file_text]').val(fn);

            that.updateSubmitButton();
        });

        var $dropZone = $(i18n.processLocalizedString('<div class="full-drop-zone"><div class="description-wrapper"><div class="description">{file_controls.drop_file_description}</div></div></div>', {
            'gender': app.getGender()
        }));

        FileHelper.registerGlobalDropZone(that.$el, $dropZone);

        $dropZone.on('drop', function (event) {

            event.preventDefault();

            $fileInput[0].files = event.originalEvent.dataTransfer.files; // This fires the 'change' event

        });

        return that;
    },

    stopUploadingCsv: function () {
        var that = this;

        if (that._uploadXhr) {
            that._uploadXhr.abort();
            that._uploadXhr = null;
        }

        return that;
    },

    remove: function () {
        var that = this;

        FileHelper.unregisterGlobalDropZone(that.$el);

        this.vueApp.$destroy();

        that.stopUploadingCsv();

        ContactsImportPage.__super__.remove.apply(this, arguments);
    }


});

export default ContactsImportPage;
